import { CompanyLegalStatutes } from "../../../../../../../../types/models/company/company.types";
import { FormItem } from "../../../../../../../commons/Form/Form.types";
import { CreateAccountManuallyFormSchema } from "./CreateAccountManuallyForm.types";

export const createAccountManuallyFormData: FormItem<CreateAccountManuallyFormSchema>[][] = [
  [
    {
      name: 'name',
      placeholder: 'Entreprise...',
      label: "Nom de l'entreprise",
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'legalStatutes',
      placeholder: `Forme jurique de l'entreprise...`,
      label: 'Forme juridique',
      type: 'select',
      id: 'legal-statutes',
      required: true,
      options: Object.keys(CompanyLegalStatutes).map((key) => ({
        value: key,
        label: CompanyLegalStatutes[key as keyof typeof CompanyLegalStatutes],
      })),
    },
  ],
  [
    {
      name: 'plan',
      placeholder: "Nombre d'employés de l'entreprise...",
      label: "Nombre d'employés",
      type: 'select',
      id: 'plan',
      required: true,
    },
  ],
  [
    {
      name: 'address',
      placeholder: 'Votre adresse...',
      label: 'Adresse',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'city',
      placeholder: 'Votre ville...',
      label: 'Ville',
      type: 'text',
      required: true,
    },
    {
      name: 'postalCode',
      placeholder: 'Votre code postal...',
      label: 'Code postal',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'department',
      placeholder: 'Votre département...',
      label: 'Département',
      type: 'text',
      required: true,
    },
    {
      name: 'region',
      placeholder: 'Votre région...',
      label: 'Région',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'siret',
      placeholder: 'Numéro siret...',
      label: 'Siret',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'tva',
      placeholder: 'Numéro TVA...',
      label: 'TVA',
      type: 'text',
    },
  ],
  [
    {
      name: 'firstName',
      placeholder: 'Prénom...',
      label: 'Prénom',
      type: 'text',
      // required: true,
    },
    {
      name: 'lastName',
      placeholder: 'Nom...',
      label: 'Nom',
      type: 'text',
      // required: true,
    },
  ],
  [
    {
      name: 'email',
      placeholder: 'Email...',
      label: 'Email',
      type: 'text',
      required: true,
    },
    {
      name: 'phone',
      placeholder: 'N° de téléphone...',
      label: 'N° de téléphone',
      type: 'text',
      // required: true,
    },
  ],
  [
    {
      name: 'function',
      placeholder: 'Fonction...',
      label: 'Fonction',
      type: 'text',
      // required: true,
    },
  ]
];
